import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.stopPropagation()
    this.element.classList.toggle("is-active")
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.element.classList.remove("is-active")
    }
  }

  connect() {
    this._hideHandler = this.hide.bind(this)
    document.addEventListener("click", this._hideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._hideHandler)
  }
}
